import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { H_CAMPAIGN_QUALITO_DASHBOARD } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import ProgressCard from '../../../components/card/ProgressCard'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import QualityCampaign from './QualityCampaign'
import { Stack } from '@mui/material'


const QualityCampaignDashboard = () => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_QUALITO_DASHBOARD)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
        }
        dispatch(CampaignAction.loadQualityCampaignDashboard(p => setProgress(p)))
            .then(() => setDataLoaded(true))
    }, [])

    if (!dataLoaded) {
        return (
            <Stack padding={1}>
                <ProgressCard progress={progress} />
            </Stack>
        )
    }
    return (
        <QualityCampaign />
    )
}

export default QualityCampaignDashboard
